import React, { useEffect, useState } from "react";
import {
  availableFobHippodromes,
  availableFobHippodromesSubject,
  BulletinMap,
  courseColors,
  racesActionSubject,
} from "../../../store/bulletin.store";
import { useForceUpdate } from "../../../services/misc.functions";
import _ from "lodash";
import "../fob-betting.css";
import { getPrettyFormatLastSix } from "../../../services/bulletin.service";
import { Link } from "react-router-dom";
import { OddButton, RaceCountdown } from "./fob.cards";
import jokeyIcon from "../../../assets/img/jokey.png";
import { isMobile } from "../../../App";

export function FobHeader({ run, forceUpdate }: any) {
  return (
    <>
      {isMobile ? (
        <>
          <div className={"d-flex justify-content-between flex-column fob-header"}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className={"mb-0 fw-bold"}>{BulletinMap[run.hippodrome_id].hippodrome}</h5>
              </div>

              <div className="fw-light " style={{ fontSize: "11px" }}>
                Ganyan - Sabit İhtimalli
              </div>
            </div>
            <div className={"d-flex justify-content-between align-items-center"}>
              <div className="d-flex flex-column hippodrome-conditions">
                <div className="fw-light text-nowrap">
                  Sıcaklık: {BulletinMap[run.hippodrome_id].weather.temperature}°C
                </div>
                <div className="fw-light">Nem: %{BulletinMap[run.hippodrome_id].weather.humidity}</div>
              </div>
              <div className="d-flex align-items-center">
                <div className="fob-row">
                  <div className={"mx-1"}>
                    <div>
                      <Link
                        to={`/tjk-at-yarisi-bulteni-bahis-yap/${BulletinMap[run.hippodrome_id].keyword.toLowerCase()}${
                          BulletinMap[run.hippodrome_id]._id
                        }/yorumlar`}
                        className="btn btn-secondary fw-semibold fs-6 "
                      >
                        YORUMLAR
                      </Link>
                    </div>
                  </div>
                  <div className="mx-1">
                    <div className={`nowrap`}>
                      <Link to={`/tjk-tv-atyarisi-izle-canli-yayin`} className="btn btn-secondary fw-semibold fs-6 ">
                        <img
                          alt={"videoIcon"}
                          src={
                            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkuNzExIDIwLS41OTUtLjI5OGMtLjA1LS4wMjUtLjA3NS0uMDI1LS4xLS4wNS00LjIxOS0yLjIzMy02LjEzLTQuNTQxLTYuOS01LjczM0MxLjEgMTIuMzgxIDEgMTAuNTQ0IDEgMTAuMzQ2VjEuMjEybC45OTMtLjI0OEM2LjM4Ni0uMDc4IDguOTY3LS4wMjggOS42ODYuMDIxYy43Mi0uMDUgMy4zMDEtLjEgNy42OTQuOTQzbC45OTMuMjQ4djkuMTM0YzAgLjIyMy0uMTI0IDIuMDM1LTEuMTE3IDMuNTk4LS43NyAxLjE5Mi0yLjY4IDMuNS02LjkyNCA1LjczM2wtLjYyLjMyM1pNMS41MjEgMS42MXY4LjcxYzAgLjA3NS4xIDEuODYyIDEuMDQzIDMuMzI2Ljc0NCAxLjE0MiAyLjU4IDMuMzc2IDYuNyA1LjU2LjAyNS4wMjUuMDUuMDI1LjA3NS4wNWwuMzcyLjE3My4zNzMtLjE5OGM0LjE0NC0yLjE4NCA1Ljk4LTQuNDE4IDYuNzI1LTUuNTYuOTQzLTEuNDY0IDEuMDQzLTMuMjUgMS4wNDMtMy4zMjVWMS42MzRsLS41OTYtLjE0OUMxMi45MTMuNDQzIDEwLjM4MS40OTMgOS43MTEuNTQyaC0uMDQ5Yy0uNjctLjA1LTMuMjAyLS4wOTktNy41NDUuOTQzbC0uNTk2LjEyNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNMTAuNzU0IDUuNThjLS4yNDgtLjA1LS4zOTctLjA1LS4zOTctLjA1LjE0OSAwIC4yNzMuMDI2LjM5Ny4wNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNOS43IDEuMTE5Yy42MjgtLjA0NCAyLjg4Mi0uMDg4IDYuNzE4LjgzM2wuODY3LjIydjcuMDczSDkuN2guMDExTDkuNyAxLjExOVoiIGZpbGw9IiNGRjAwMjAiLz48cGF0aCBkPSJNMi45ODIgOWgtLjg2N3YxLjAzN2MwIC4xOTcuMTA4IDEuNzk5Ljk3NSAzLjE4MS42NzIgMS4wNTMgMi4zNCAzLjA5MyA2LjA0NiA1LjA2OGwuNTQyLjI4NVY5SDIuOTgyWiIgZmlsbD0iIzJBMUQzMCIvPjwvc3ZnPg=="
                          }
                          width={18}
                          className={"me-1"}
                        />
                        TV
                      </Link>
                    </div>
                  </div>
                  {/* <div className="mx-1">
                    <div className="dropdown">
                      <button
                        className="btn btn-secondary fw-semibold fs-6 dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                        >
                          <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                        </svg>
                      </button>
                      <ul className="dropdown-menu bg-white">
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              run.horses = _.orderBy(run.horses, [(a: any) => Number(a["no"])], ["asc"]);
                              forceUpdate();
                            }}
                          >
                            No'ya Göre
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              run.horses = _.orderBy(run.horses, ["agf_ratio1"], ["desc"]);
                              forceUpdate();
                            }}
                          >
                            AGF'ye Göre
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              run.horses = _.orderBy(
                                run.horses,
                                [(a: any) => Number(run.event_odds[Number(a.no)]?.win_odds)],
                                ["asc"]
                              );
                              forceUpdate();
                            }}
                          >
                            Oran'a Göre
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              run.horses = _.orderBy(run.horses, ["start"], ["desc"]);
                              forceUpdate();
                            }}
                          >
                            Kulvar'a Göre
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-block mb-0 py-0 fw-bold ">
                  <div className="d-flex  justify-content-center align-items-center fs-5 next-run">
                    <span className="fs-6 text-nowrap">Sıradaki koşu</span>
                    <div className={"d-flex justify-content-center align-items-center"}>
                      <RaceCountdown hippodrome={BulletinMap[run.hippodrome_id]} run={run}></RaceCountdown>
                      <span className="fs-6 ms-1">{"  sonra."}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={"d-flex justify-content-between align-items-center fob-header"}>
          <div className="d-flex flex-column">
            <div className={"d-flex align-items-center"}>
              <h5 className="card-title mb-0">{BulletinMap[run.hippodrome_id].hippodrome}</h5>
            </div>
            <div className="d-flex justify-content-between align-items-center hippodrome-conditions">
              <div className="fw-light">Sıcaklık: {BulletinMap[run.hippodrome_id].weather.temperature}°C</div>
              <div className="fw-light">Nem: %{BulletinMap[run.hippodrome_id].weather.humidity}</div>
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div className="fob-row">
              <div className={"mx-1"}>
                <div>
                  <Link
                    to={`/tjk-at-yarisi-bulteni-bahis-yap/${BulletinMap[run.hippodrome_id].keyword.toLowerCase()}${
                      BulletinMap[run.hippodrome_id]._id
                    }/yorumlar`}
                    className="btn btn-secondary fw-semibold fs-6 "
                  >
                    YORUMLAR
                  </Link>
                </div>
              </div>
              <div className="mx-1">
                <div className={`nowrap`}>
                  <Link to={`/tjk-tv-atyarisi-izle-canli-yayin`} className="btn btn-secondary fw-semibold fs-6 ">
                    <img
                      alt={"videoIcon"}
                      src={
                        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTkuNzExIDIwLS41OTUtLjI5OGMtLjA1LS4wMjUtLjA3NS0uMDI1LS4xLS4wNS00LjIxOS0yLjIzMy02LjEzLTQuNTQxLTYuOS01LjczM0MxLjEgMTIuMzgxIDEgMTAuNTQ0IDEgMTAuMzQ2VjEuMjEybC45OTMtLjI0OEM2LjM4Ni0uMDc4IDguOTY3LS4wMjggOS42ODYuMDIxYy43Mi0uMDUgMy4zMDEtLjEgNy42OTQuOTQzbC45OTMuMjQ4djkuMTM0YzAgLjIyMy0uMTI0IDIuMDM1LTEuMTE3IDMuNTk4LS43NyAxLjE5Mi0yLjY4IDMuNS02LjkyNCA1LjczM2wtLjYyLjMyM1pNMS41MjEgMS42MXY4LjcxYzAgLjA3NS4xIDEuODYyIDEuMDQzIDMuMzI2Ljc0NCAxLjE0MiAyLjU4IDMuMzc2IDYuNyA1LjU2LjAyNS4wMjUuMDUuMDI1LjA3NS4wNWwuMzcyLjE3My4zNzMtLjE5OGM0LjE0NC0yLjE4NCA1Ljk4LTQuNDE4IDYuNzI1LTUuNTYuOTQzLTEuNDY0IDEuMDQzLTMuMjUgMS4wNDMtMy4zMjVWMS42MzRsLS41OTYtLjE0OUMxMi45MTMuNDQzIDEwLjM4MS40OTMgOS43MTEuNTQyaC0uMDQ5Yy0uNjctLjA1LTMuMjAyLS4wOTktNy41NDUuOTQzbC0uNTk2LjEyNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNMTAuNzU0IDUuNThjLS4yNDgtLjA1LS4zOTctLjA1LS4zOTctLjA1LjE0OSAwIC4yNzMuMDI2LjM5Ny4wNVoiIGZpbGw9IiMyQTFEMzAiLz48cGF0aCBkPSJNOS43IDEuMTE5Yy42MjgtLjA0NCAyLjg4Mi0uMDg4IDYuNzE4LjgzM2wuODY3LjIydjcuMDczSDkuN2guMDExTDkuNyAxLjExOVoiIGZpbGw9IiNGRjAwMjAiLz48cGF0aCBkPSJNMi45ODIgOWgtLjg2N3YxLjAzN2MwIC4xOTcuMTA4IDEuNzk5Ljk3NSAzLjE4MS42NzIgMS4wNTMgMi4zNCAzLjA5MyA2LjA0NiA1LjA2OGwuNTQyLjI4NVY5SDIuOTgyWiIgZmlsbD0iIzJBMUQzMCIvPjwvc3ZnPg=="
                      }
                      width={18}
                      className={"me-1"}
                    />
                    TV
                  </Link>
                </div>
              </div>
              {/* <div className="mx-1">
                <div className="dropdown">
                  <button
                    className="btn btn-secondary fw-semibold fs-6 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                    </svg>
                  </button>
                  <ul className="dropdown-menu bg-white">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          run.horses = _.orderBy(run.horses, [(a: any) => Number(a["no"])], ["asc"]);
                          forceUpdate();
                        }}
                      >
                        No'ya Göre
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          run.horses = _.orderBy(run.horses, ["agf_ratio1"], ["desc"]);
                          forceUpdate();
                        }}
                      >
                        AGF'ye Göre
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          run.horses = _.orderBy(
                            run.horses,
                            [(a: any) => Number(run.event_odds[Number(a.no)]?.win_odds)],
                            ["asc"]
                          );
                          forceUpdate();
                        }}
                      >
                        Oran'a Göre
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => {
                          run.horses = _.orderBy(run.horses, ["start"], ["desc"]);
                          forceUpdate();
                        }}
                      >
                        Kulvar'a Göre
                      </button>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
          <div className="d-flex">
            <div className="mb-0 px-2 py-0 fw-bold ">
              <div className="d-block mb-0 px-2 py-0 fw-bold ">
                <div className="fw-light d-none d-md-block">Ganyan - Sabit İhtimalli</div>

                <div className="d-flex  justify-content-center align-items-center fs-5 next-run">
                  <span className="fs-6">Sıradaki koşu&nbsp;</span>
                  <div className={"d-flex justify-content-center align-items-center"}>
                    <RaceCountdown hippodrome={BulletinMap[run.hippodrome_id]} run={run}></RaceCountdown>

                    <span className="fs-6 ms-1">{"  sonra."}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export function FobBody({ run }: any) {
  const forceUpdate = useForceUpdate();
  var sort: any;

  return (
    <div className="page-widget mb-2" style={{ borderRadius: 0 }}>
      <div className="card run-card">
        <div className="card-body">
          {isMobile ? (
            <>
              <div className={"row align-items-center p-1"}>
                <div className="col-7 d-flex flex-column">
                  <div className={"d-flex align-items-center"}>
                    <h5 className="card-title mb-0">{run.no}.Koşu</h5>

                    <span className="course mx-1" style={{ backgroundColor: courseColors[run.course] }}>
                      {run.course}
                    </span>
                    <span className={"fw-medium"}>{run?.distance}m</span>
                  </div>
                  <div>
                    <p className="fw-medium mb-0" style={{ fontSize: isMobile ? "14px" : "10px" }}>
                      {run?.group} {run?.type_detail || ""} {run?.gender || ""} {run?.gender_detail || ""}
                    </p>
                  </div>
                </div>

                <div className="col-5 d-flex flex-column mb-0">
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end gap-2">
                      <div className="dropdown dropdown-without-arrow">
                        <button
                          className={`btn btn-sm btn-outline-primary dropdown-toggle px-1 py-0`}
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                          </svg>
                        </button>
                        <ul className="dropdown-menu bg-white">
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                sort = "no";
                                run.horses = _.orderBy(run.horses, [(a: any) => Number(a[sort.toString()])], ["asc"]);
                                forceUpdate();
                              }}
                            >
                              No'ya Göre
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"

                              onClick={() => {
                                sort = "agf_ratio1";
                                run.horses = _.orderBy(run.horses, ["agf_ratio1"], ["desc"]);
                                forceUpdate();
                              }}
                            >
                              AGF'ye Göre
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"

                              onClick={() => {
                                run.horses = _.orderBy(
                                  run.horses,
                                  [(a: any) => Number(run.event_odds[Number(a.no)]?.win_odds)],
                                  ["asc"]
                                );
                                forceUpdate();
                              }}
                            >
                              Oran'a Göre
                            </button>
                          </li>
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                run.horses = _.orderBy(run.horses, ["start"], ["desc"]);
                                forceUpdate();
                              }}
                            >
                              Kulvar'a Göre
                            </button>
                          </li>
                        </ul>
                      </div>
                      <p className={"mb-0 fw-bold"}>{run.time}</p>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end">
                    {/* <p className="fw-bold text-nowrap mb-0 align-self-end">Sabit Oranlı Ganyan</p> */}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="row" style={{ marginLeft: "1px" }}>
              <div className="col-8 d-flex flex-row">
                <div>
                  <div className={"d-flex align-items-center"}>
                    <h5 className="card-title mt-2">{run.no}. Koşu</h5>
                    <span className="course mx-1" style={{ backgroundColor: courseColors[run.course] }}>
                      {run.course}
                    </span>
                    <div className="fw-medium">{run.distance}m</div>
                  </div>
                  <div className="fw-medium" style={{ fontSize: isMobile ? "14px" : "10px" }}>
                    {run?.group}&nbsp;{run?.type_detail || ""} {run?.gender || ""}&nbsp;{run?.gender_detail || ""}
                  </div>
                </div>
              </div>

              <div className="col-3 d-flex flex-row gap-2 align-items-center justify-content-end">
                <div className="d-flex align-items-end gap-2">
                  <div className="dropdown dropdown-without-arrow">
                    <button
                      className={`btn btn-sm btn-outline-primary dropdown-toggle px-1 py-0`}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z" />
                      </svg>
                    </button>
                    <ul className="dropdown-menu bg-white">
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            sort = "no";
                            run.horses = _.orderBy(run.horses, [(a: any) => Number(a[sort.toString()])], ["asc"]);
                            forceUpdate();
                          }}
                        >
                          No'ya Göre
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            sort = "agf_ratio1";
                            run.horses = _.orderBy(run.horses, ["agf_ratio1"], ["desc"]);
                            forceUpdate();
                          }}
                        >
                          AGF'ye Göre
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            run.horses = _.orderBy(
                              run.horses,
                              [(a: any) => Number(run.event_odds[Number(a.no)]?.win_odds)],
                              ["asc"]
                            );
                            forceUpdate();
                          }}
                        >
                          Oran'a Göre
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => {
                            run.horses = _.orderBy(run.horses, ["start"], ["desc"]);
                            forceUpdate();
                          }}
                        >
                          Kulvar'a Göre
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="mb-0 fw-bold fs-6">{run.time} </p>
                {/* <div className="d-flex fw-bold">Sabit Oranlı Ganyan</div> */}
              </div>
            </div>
          )}

          {run.horses.map((el: any, i: number) => {
            return (
              <>
                <div
                  className={"d-flex fob-list-body"}
                  style={!el.run_status ? { opacity: 0.4 } : {}}
                  key={"fob-list-horse-" + el.no + i}
                >
                  <div className={"d-flex justify-content-between align-items-center "}>
                    <div
                      style={{
                        paddingRight: "5px",
                        marginRight: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        el.closeBody = !el.closeBody;
                        forceUpdate();
                      }}
                      className={el.closeBody ? "d-none" : ""}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-caret-down"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
                      </svg>
                    </div>
                    <div
                      style={{
                        paddingRight: "5px",
                        marginRight: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        el.closeBody = !el.closeBody;
                        forceUpdate();
                      }}
                      className={!el.closeBody ? "d-none" : ""}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-caret-up"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.204 11h9.592L8 5.519zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659" />
                      </svg>
                    </div>

                    <div className={"me-1"}>
                      <img
                        src={`https://medya-cdn.tjk.org/formaftp/${el.owner.code}.jpg`}
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = jokeyIcon;
                        }}
                        width={21}
                        style={{ borderRadius: "50%" }}
                        alt={el.jokey.short_name}
                        className="jockey-uniform float-start "
                      />
                    </div>
                    <div className={"d-flex flex-column align-items-start"}>
                      <div>
                        {el.run_status ? (
                          <>{el.no} - </>
                        ) : (
                          <span className="fw-bold text-danger tooltip opacity-100">
                            K - <div className="tooltip-text">KOŞMAZ</div>
                          </span>
                        )}
                        <span className="fw-bold">{el.name}</span>

                        {/* / {el.jokey.name} */}
                      </div>
                      {/*<div>*/}
                      {/*<span*/}
                      {/*    dangerouslySetInnerHTML={{__html: getPrettyFormatLastSix(el.last6)}}></span>*/}
                      {/*</div>*/}
                    </div>
                  </div>
                  <div>
                    <div className={"d-flex"} style={{ marginRight: isMobile ? "" : "100px" }}>
                      <OddButton
                        run={run}
                        horse={el}
                        forceUpdate={forceUpdate}
                        hippodrome={BulletinMap[run.hippodrome_id]}
                      ></OddButton>
                    </div>
                  </div>
                </div>

                {el.closeBody && (
                  <div className={"d-block"}>
                    <div className={"d-flex"}>
                      <div className="w-50 px-1 horse-info-fob">
                        Son 6: <span dangerouslySetInnerHTML={{ __html: getPrettyFormatLastSix(el.last6) }}></span>
                      </div>
                      <div className="w-50 px-1 horse-info-fob d-flex justify-content-between">
                        {el.agf_ratio1 && el.agf_ratio1 !== 0 ? (
                          <div className={""}>
                            AGF1:{" "}
                            <span className={`fw-bold ${el.agf_sort_no1 === 1 ? "text-success" : ""}`}>
                              %{el.agf_ratio1}
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}

                        {el.agf_ratio2 && el.agf_ratio2 !== 0 ? (
                          <div className={""}>
                            AGF2:{" "}
                            <span className={`fw-bold ${el.agf_sort_no2 === 1 ? "text-success" : ""}`}>
                              %{el.agf_ratio2}
                            </span>
                          </div>
                        ) : (
                          <></>
                        )}
                        {el.agf_ratio1 === 0 && el.agf_ratio2 === 0 && (
                          <div>
                            AGF: <span className={"fw-bold"}>-</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={"d-flex align-items-stretch"}>
                      <div className="w-50 px-1 horse-info-fob">
                        Jokey: <span className="fw-bold ms-2">{el.jokey.short_name}</span>
                      </div>

                      <div className="w-50 px-1 horse-info-fob">
                        Antrenör: <span className="fw-bold ms-2">{el.trainer.name}</span>
                      </div>
                    </div>
                    <div className={"d-flex"}>
                      <div className="w-50 px-1  fs-8 horse-info-fob">
                        Anne: <span className="fw-bold ms-2">{el.mother}</span> <br></br> Baba:{" "}
                        <span className="fw-bold ms-2">{el.father}</span>{" "}
                      </div>
                      <div className="w-50 px-1 horse-info-fob">
                        En İyi Derece: <span className="fw-bold ms-2">{el.best_time}</span>
                      </div>
                    </div>
                    <div className={"d-flex"}>
                      <div className="w-50 px-1 horse-info-fob">
                        Start: <span className="fw-bold ms-2">{el.start}</span>
                      </div>
                      <div className="w-50 px-1 horse-info-fob">
                        Kilo: <span className="fw-bold ms-2">{el.weight}KG</span>
                      </div>
                    </div>
                    <div className={"d-flex"}>
                      <div className="w-50 px-1 horse-info-fob">
                        KGS: <span className="fw-bold ms-2">{el.kgs}</span>
                      </div>
                      <div className="w-50 px-1 horse-info-fob d-flex align-items-center">
                        HP: <span className="fw-bold ms-2">{el.handicap}</span>
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export function FobList(prop: any) {
  const forceUpdate = useForceUpdate();
  const [filteredList, setFilteredList] = useState<any>([]);

  const getOrderedList = () => {
    var listedFobRuns = [];
    for (const availableFobHippodrome of availableFobHippodromes) {
      for (const run of availableFobHippodrome.runs) {
        run.hippodrome_id = availableFobHippodrome._id;
        listedFobRuns.push(run);
      }
    }

    listedFobRuns = _.orderBy(listedFobRuns, ["running_date"], ["asc"]);
    setFilteredList(listedFobRuns);
  };

  useEffect(() => {
    let availableHippodromesSubject_subscription = availableFobHippodromesSubject.subscribe((res: any) => {
      forceUpdate();
    });
    return () => {
      availableHippodromesSubject_subscription.unsubscribe();
    };
  });

  useEffect(() => {
    let racesActionSubject_subscription = racesActionSubject.subscribe((res: any) => {
      if (res && res.action === "update") {
        forceUpdate();
        getOrderedList();
      }
    });
    return () => {
      racesActionSubject_subscription.unsubscribe();
    };
  });

  useEffect(() => {
    getOrderedList();
  }, []);

  return (
    <>
      {filteredList.map((el: any, index: any) => {
        if (el.fob_wager_status) {
          return (
            <div>
              <FobHeader run={el} forceUpdate={forceUpdate}></FobHeader>
              <FobBody key={"fob-body" + index} run={el}></FobBody>
            </div>
          );
        }
      })}
    </>
  );
}
